import { Environment } from "../../../../../Config/constants/environment";
import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { SubCategory } from "../../../Domain/Model/SubCategory";
import SubCategoryDataSource from "../SubCategoryDataSource";
import { SubCategoryAPIEntity } from "./Entity/SubCategoryAPIEntity";

const routeName = `/v1/subcategory`;
export default class SubCategoryAPIDataSourceImpl implements SubCategoryDataSource {
  
  
  async createSubCategory(data: SubCategory): Promise<boolean> {

      const formData = new FormData();

          formData.append("Name", data.name);
          formData.append("CategoryId", String(data.categoryId));

          formData.append("Image",  data.imageUrl);

    try {
        
        // Realiza la petición POST utilizando api
        // const response = await api.post<ApiResponse<any>>(routeName, formData, {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //   }
        // });
        const response = await api.post<ApiResponse<any>>(routeName, formData,  {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        });
        
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Mapea los datos de la respuesta al formato de CategoryAPIEntity que esperas
          const categories = response.data.succeeded;
          
          return categories;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al agregar la sub categoría:", error);
        throw new Error("Error al agregar la sub categoría");
      }
    }
    
    
    async getSubCategories(): Promise<SubCategoryAPIEntity[]> {
      try {
        const response = await api.get<ApiResponse<any>>(routeName);
        // console.log(response.data.data);
        const listCategories = response.data.data;
        // Verifica si la respuesta contiene datos
        if (listCategories && Array.isArray(listCategories)) {
          // Mapea los datos de la respuesta al formato de Category que esperas
          const categories: SubCategory[] = listCategories.map((item: any) => ({
            id: item.id,
            name: item.name,
            imageUrl: item.imageUrl,
            categoryId: item.categoryId,
            category: item.category
          }));
          
          return categories;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al obtener las sub categorías:", error);
        throw new Error("Error al obtener las sub categorías");
      }
    }

    async updateSubCategory(data: SubCategory): Promise<boolean> {
      const formData = new FormData();
          formData.append("Id", String(data.id));
          formData.append("Name", data.name);
          formData.append("CategoryId", String(data.categoryId));

          formData.append("Image",  data.imageUrl);
      try {
        // Realiza la petición PUT utilizando api
        const response = await api.put<ApiResponse<any>>(`${routeName}`, formData, {
           headers: {
            "Content-Type": "multipart/form-data",
          }
        });
  
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Devuelve true si la actualización fue exitosa
          return true;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al actualizar la sub categoría:", error);
        throw new Error("Error al actualizar la sub categoría");
      }
    }

    async removeSubCategory(id: string): Promise<boolean> {
      try {
        // Realiza la petición DELETE utilizando api
        const response = await api.delete<ApiResponse<any>>(`${routeName}/${id}`);
  
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Devuelve true si la eliminación fue exitosa
          return true;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al eliminar la sub categoría:", error);
        throw new Error("Error al eliminar la sub categoría");
      }
    }
   
  }